const uploadData = (state = [], action) => {
  let newState = {};
  let newData = {};
  switch (action.type) {
    case "SET_UPLOAD_DATA":
      newData = {
        uploadData: action.data,
      };

      newState = {
        ...state,
        ...newData,
      };

      return newState;
    case "SET_UPLOAD_LOADING":
      newData = {
        uploadLoading: action.data.loading,
        uploadComplete: action.data.uploadComplete,
        uploadError: action.data.error,
        uploadErrorMessage: action.data.uploadErrorMessage,
        uploadData: action.data.uploadData,
      };

      newState = {
        ...state,
        ...newData,
      };
      return newState;
    case "SET_PATIENT_DATA":
      newState = {
        ...state,
        patientData: action.data,
      };
      return newState;
    default:
      return state;
  }
};

export default uploadData;
